import React from "react";
import { SvgIcon } from "@mui/material";
import styles from "../../icons/iconStyles";

const MagnifierIcon = ({ color }: any) => {
  return (
    <SvgIcon style={styles.icon}>
      <svg width="24" height="24" viewBox="0 0 23 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.7853 19.5002L14.7397 16.1562" stroke={color || "white"} strokeWidth="2" strokeLinecap="round" />
        <ellipse cx="10.4991" cy="11.5" rx="5.46446" ry="6" stroke={color || "white"} strokeWidth="2" strokeLinecap="square" />
      </svg>
    </SvgIcon>
  );
}

export default MagnifierIcon;
